var _defs, _rect, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentActiveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#009de0;}.b{fill:#fff;}.c{fill:none;stroke:#009de0;stroke-linecap:round;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 32,
    height: 32,
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16508.656,22740.773H16503a2,2,0,0,1-2-2V22730a2,2,0,0,1,2-2h12a2,2,0,0,1,2,2v8.768a2,2,0,0,1-2,2h-1V22744Z",
    transform: "translate(-16493.002 -22719)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-563 -472)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 9,
    transform: "translate(574.5 484.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 9,
    transform: "translate(574.5 486.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 9,
    transform: "translate(574.5 488.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 6,
    transform: "translate(574.5 490.5)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentActiveIcon);
export default __webpack_public_path__ + "static/media/commentActiveIcon.5dad35e920c1d56491f0e873a689337e.svg";
export { ForwardRef as ReactComponent };